<template>
  <tbody>
  <tr :class="[{more_info: isEditable && $_updateActionAllowed}, { open: isOpen }, {disabled: !isEditable}]" @click="triggerIfEditable">
    <td :data-th="'Protokol' | translate" class="first_data">{{ itemProtocolName }}</td>
    <td :data-th="'Max. délka TimeShiftu' | translate">{{ maxTimeshift }}</td>
    <td :data-th="'Max. délka CatchUpu' | translate">{{ maxCatchup }}</td>
    <td :data-th="'Max. délka uložení nahrávek' | translate">{{ maxPvr }}</td>
    <td class="no_padding edit">
      <div class="edit_inner" v-if="isEditable">
        <a
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.stop.prevent="deleteNonlinearContent"
            v-translate>Smazat
        </a>
      </div>
    </td>
  </tr>
  <tr :class="['more_info_content', { open: isOpen }]">
    <td class="first_data">
      <select-box
          :id="idProtocol"
          v-model="editedItem.id_protocol"
          :options="protocolOptions">
        <translate class="translate">Protokol</translate>
      </select-box>
    </td>
    <td>
      <text-input
          :id="idMaxTimeshift"
          v-model="editedTimeshift"
          :ref="item.id + '-timeshiftref'">
        <translate class="translate">Max. délka TimeShiftu</translate>
      </text-input>
    </td>
    <td>
      <text-input
          :id="idMaxCatchup"
          v-model="editedItem.catchup_maximum_length_in_hours"
          :ref="item.id + '-catchupref'">
        <translate>Max. délka CatchUpu</translate>
      </text-input>
    </td>
    <td class="last_data">
      <text-input
          :id="idMaxPvr"
          :with-submit="true"
          @submit="updateNonlinearContent"
          v-model="editedItem.pvr_maximum_length_in_days"
          :ref="item.id + '-pvrref'">
        <translate class="translate">Max. délka uložení nahrávek</translate>
      </text-input>
    </td>
    <td><p></p></td>
  </tr>
  </tbody>
</template>

<script>
import {getTextByValue} from "@/utils/helpers"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "NonlinearContentRow",
  mixins: [requiredFields],
  created() {
    this.editedItem = this._.pick(this.item, this.keysToPick)
  },
  data() {
    return {
      isOpen: false,
      editedItem: {
        id_protocol: null,
        timeshift_maximum_length_in_minutes: null,
        catchup_maximum_length_in_hours: null,
        pvr_maximum_length_in_days: null
      },
      keysToPick: [
        'id',
        'id_protocol',
        'timeshift_maximum_length_in_minutes',
        'catchup_maximum_length_in_hours',
        'pvr_maximum_length_in_days'
      ],
    }
  },
  props: {
    item: Object,
    isEditable: Boolean,
    protocolOptions: Array,
  },
  computed: {
    editedTimeshift: {
      get() {
        return this.editedItem.timeshift_maximum_length_in_minutes
      },
      set(newValue) {
        if (newValue === '' || newValue === 0) {
          newValue = null
        }
        this.editedItem.timeshift_maximum_length_in_minutes = newValue
      }
    },
    itemProtocolName() {
      return getTextByValue(this.protocolOptions, this.item.id_protocol)
    },
    idProtocol() {
      return 'edit-nonlinear-protocol-' + this.item.id
    },
    idMaxTimeshift() {
      return 'edit-nonlinear-timeshift-' + this.item.id
    },
    idMaxCatchup() {
      return 'edit-nonlinear-catchup-' + this.item.id
    },
    idMaxPvr() {
      return 'edit-nonlinear-pvr-' + this.item.id
    },
    maxTimeshift() {
      return (!!this.item.timeshift_maximum_length_in_minutes ? this.item.timeshift_maximum_length_in_minutes : 0) + ' min'
    },
    maxCatchup() {
      return (!!this.item.catchup_maximum_length_in_hours ? this.item.catchup_maximum_length_in_hours : 0) + ' h'
    },
    maxPvr() {
      return (!!this.item.pvr_maximum_length_in_days ? this.item.pvr_maximum_length_in_days : 0) + ' dní'
    }
  },
  methods: {
    updateNonlinearContent() {
      this.$emit('submit', {...this.editedItem})
    },
    deleteNonlinearContent() {
      this.$emit('delete', this.item.id)
    },
    triggerIfEditable() {
      if (this.isEditable && this.$_updateActionAllowed) {
        this.isOpen = !this.isOpen
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/NonlinearContentRow.vue